import { ref } from "vue";
import { useAsyncState } from "@vueuse/core";
import { useTemporal } from "./useTemporal";

export type SchemaStatus =
  | { type: "idle" }
  | { type: "loading" }
  | { type: "error"; heading: string; message: string };

export const useFormSchema = () => {
  const schema = ref<unknown>();
  const status = ref<SchemaStatus>({ type: "loading" });
  const { now } = useTemporal();

  const { execute } = useAsyncState(
    async () => {
      const formId = import.meta.env.VITE_HUBSPOT_FORM_ID || "default";
      const response = await fetch(`/api/forms/${formId}`);
      if (!response.ok) {
        status.value = {
          type: "error",
          heading: "Form unavailable",
          message: "We cannot load the ticket form right now."
        };
        return;
      }
      const payload = await response.json();
      schema.value = payload;
      status.value = { type: "idle" };
    },
    undefined,
    { immediate: true }
  );

  return {
    schema,
    status,
    refresh: execute,
    fetchedAt: ref(now())
  };
};
